const slice = (o: number, n: number) => Array.prototype.slice.call(o, n);

export { slice };
